/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_PlayInputs */

const en_mascot_play = /** @type {(inputs: Mascot_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play mascot animation`)
};

const id_mascot_play = /** @type {(inputs: Mascot_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putar animasi maskot`)
};

/**
* | output |
* | --- |
* | "Play mascot animation" |
*
* @param {Mascot_PlayInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mascot_play = /** @type {((inputs?: Mascot_PlayInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_PlayInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mascot_play(inputs)
	return en_mascot_play(inputs)
});